var React = require('react');

function GradientMonitor (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.66 3H26.325C31.665 3 33 4.335 33 9.66V19.155C33 24.495 31.665 25.815 26.34 25.815H9.66C4.335 25.83 3 24.495 3 19.17V9.66C3 4.335 4.335 3 9.66 3Z","stroke":"#247E7A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18 25.8301V33.0001","stroke":"#247E7A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3 19.5H33","stroke":"#247E7A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M11.25 33H24.75","stroke":"#247E7A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

GradientMonitor.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = GradientMonitor;

GradientMonitor.default = GradientMonitor;
